export default __webpack_public_path__ + "static/media/logo512.08c89547.png";